import type { audit as en } from '@/i18n/locales/en/audit';
import type { Translation } from '@/i18n/types';

export const audit: Translation<typeof en> = {
  page: {
    title: 'Registo de auditoria',
    scopedLead:
      'Vê as ações permitidas para as tuas próprias empresas; as respostas de consentimento e as ligações de identidade nunca são incluídas.',
    actionFilter: 'Filtrar por ação',
    actionPlaceholder: 'ação, p. ex. department.visibility.update',
    scopeFilter: 'Filtrar por âmbito',
    scopePlaceholder: 'id do âmbito',
    filter: 'Filtrar',
    empty: 'Sem linhas de auditoria.',
    when: 'Quando',
    action: 'Ação',
    actorRole: 'Função do autor',
    target: 'Alvo',
    rowsLabel: 'as linhas de auditoria',
  },
};
